import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const graceSubscriptionsUI = isFeature('grace-subscriptions-ui');
